import type { CreatedTicket } from "./RequestModalShell";

type JsonRecord = Record<string, unknown>;

const isRecord = (value: unknown): value is JsonRecord =>
  typeof value === "object" && value !== null;

const asKey = (value: unknown): string | null =>
  typeof value === "string" && value.trim() ? value : null;

/**
 * The Jira key of a ticket that was just created. Kontrol Edge answers
 * `{ ticket: <JSM request> }`, whose key is `issueKey`; the CTX Reflector
 * endpoint returns the Jira response itself. Anything else leaves the key
 * out, and the success screen says so without one.
 */
export function getCreatedTicket(responseData: unknown): CreatedTicket {
  if (!isRecord(responseData)) return { key: null, warning: null };
  const ticket = isRecord(responseData.ticket) ? responseData.ticket : null;
  return {
    key:
      asKey(ticket?.issueKey) ??
      asKey(responseData.issueKey) ??
      asKey(responseData.key),
    warning: null,
  };
}
